import { ReactElement } from 'react'

interface Props {
  alt?: string
  // Streamdown passes the hast node to every element renderer.
  node?: unknown
}

/**
 * Replaces images (and other auto-loading media) in chat answers by their
 * alt text. The answer can repeat text an attacker planted in project data;
 * an image URL is fetched without a click, so it could carry project data to
 * any host. Links stay, they need a click.
 */
const BlockedMedia = ({ alt }: Props): ReactElement | null =>
  alt ? <span>[Bild: {alt}]</span> : null

export default BlockedMedia
